<template>
  <wnb-roles-mapping-form></wnb-roles-mapping-form>
</template>

<script>
import WnbRolesMappingForm from "../../../../components/Settings/WnbRolesMappingForm";
export default {
  name: "SettingsRoleMappingNewView",
  components: { WnbRolesMappingForm }
};
</script>

<style scoped></style>
